import React from "react";
import compareValues from "../utils/compareValues";
import basePath from "../utils/basePath";

import FamilyName from "./FamilyName";
import BuildAvatar from "./BuildAvatar";
import ViewAvatar from "./ViewAvatar";
import Results from "./Results";
import ViewFamily from "./ViewFamily";
import axios from "axios";

//Extend the storage object to allow for setting and getting objects in local storage
Storage.prototype.setObject = function (key, value) {
  this.setItem(key, JSON.stringify(value));
};
Storage.prototype.getObject = function (key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
};

class App extends React.Component {
  state = {
    family: [],
    familyname: "",
    step: "FamilyName",
    editId: null,
    avatarOptions: null,
    locations: null,
  };
  componentDidMount() {
    //Get state from local storage
    if (window.ga) {
      window.ga("set", "page", `/2020/${this.state.step}`);
      window.ga("send", "pageview");
    }
    let storedState = localStorage.getObject("state"),
      requestOptions = axios.get(basePath + "json/avatar-options.json"),
      requestLocations = axios.get(basePath + "json/locations.json");

    axios
      .all([requestOptions, requestLocations])
      .then(
        axios.spread((...res) => {
          this.setState({
            ...storedState,
            avatarOptions: res[0].data,
            locations: res[1].data,
          });
          // use this version for returning users to land on the results page
          // let step = "FamilyName";
          // if (storedState.family.length > 0) {
          //   step = "Results";
          // }
          // this.setState({
          //   ...storedState,
          //   avatarOptions: res[0].data,
          //   locations: res[1].data,
          //   step,
          // });
        })
      )
      .catch((err) => {
        console.log(err);
      });
  }
  componentDidUpdate() {
    //Update local storage to match state
    localStorage.setObject("state", this.state);
  }
  clearAllRecords = () => {
    localStorage.clear();
    if (window.ga) {
      window.ga("send", "event", "Actions", "Click", "Restart");
    }
    this.setState({
      family: [],
      step: "FamilyName",
      familyname: "",
      editId: null,
    });
  };
  updateMember = (data) => {
    //Filter out the matching id to remove the previous record if one exists
    let filtered = this.state.family.filter((value) => {
      return value.id !== data.id;
    });
    //Add a new record then sort by id
    let newData = [...filtered, data].sort(compareValues("id"));

    if (this.state.editId && window.ga) {
      window.ga("send", "event", "Actions", "Click", "Edit avatar");
    } else if (window.ga) {
      window.ga("send", "event", "Actions", "Click", "New avatar");
    }
    if (window.ga) {
      window.ga("send", "event", "Accessories Selected", "Submit", newData[0].accessories.name);
      window.ga("send", "event", "Gear Selected", "Submit", newData[0].gear.name);
      window.ga("send", "event", "Outfit Selected", "Submit", newData[0].outfit.name);
      window.ga("send", "event", "Background Selected", "Submit", newData[0].scenery.name);
    }
    this.setState({ family: newData, editId: null });
  };
  updateFamilyName = (familyname) => {
    this.setState({ familyname });
  };
  goTo = (step, editId = null) => {
    // window.digitalData.page.pageInfo.pageName = `Vacavatar Game - ${step}`;
    // if (window._satellite) {
    //   window._satellite.track("pageChange");
    // }
    if (window.ga) {
      window.ga("set", "page", `/2020/${step}`);
      window.ga("send", "pageview");
    }
    window.scroll(0, 0);
    if ("activeElement" in document) {
      document.activeElement.blur();
    }
    this.setState({ step, editId });
  };
  removeRecord = (recordId) => {
    //Remove a record
    let filtered = this.state.family.filter((value) => {
      return value.id !== recordId;
    });
    this.setState({
      family: filtered,
    });
  };
  stepController = () => {
    if (this.state.locations && this.state.avatarOptions) {
      switch (this.state.step) {
        case "FamilyName":
          return <FamilyName goTo={this.goTo} updateFamilyName={this.updateFamilyName} globalState={this.state} />;
        case "BuildAvatar":
          return <BuildAvatar goTo={this.goTo} updateMember={this.updateMember} globalState={this.state} />;
        case "ViewAvatar":
          return <ViewAvatar goTo={this.goTo} globalState={this.state} />;
        case "Results":
          return <Results goTo={this.goTo} globalState={this.state} clearAllRecords={this.clearAllRecords} />;
        case "ViewFamily":
          return <ViewFamily goTo={this.goTo} globalState={this.state} removeRecord={this.removeRecord} />;
        default:
      }
    }
    return null;
  };
  render() {
    return (
      <div className="app how2020">
        {/* <div className="dev-nav">
          <button onClick={() => this.goTo("FamilyName")}>FamilyName</button>
          <button onClick={() => this.goTo("BuildAvatar")}>BuildAvatar</button>
          <button onClick={() => this.goTo("Results")}>Results</button>
          <button onClick={() => this.goTo("ViewFamily")}>ViewFamily</button>
        </div> */}
        {this.stepController()}
      </div>
    );
  }
}
export default App;
